export const EVENTS_BREADCRUMB = {
  title: "Events",
};
